import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import api from "@/lib/api";
import { ArticleCard } from "@/components/public/ArticleCard";
import { useSeo } from "@/lib/seo";

export default function Company() {
  const { slug } = useParams();
  const [c, setC] = useState(null);
  const [nf, setNf] = useState(false);
  useEffect(() => { window.scrollTo(0,0); api.get(`/companies/${slug}`).then((r) => setC(r.data)).catch(() => setNf(true)); }, [slug]);
  useSeo(c ? {
    title: c.name,
    description: c.description,
    jsonLd: [{ "@type": "Organization", name: c.name, description: c.description,
      url: c.website || undefined, address: c.country ? { "@type": "PostalAddress", addressCountry: c.country } : undefined }],
  } : null);
  if (nf) return <div className="max-w-3xl mx-auto px-6 py-24 text-center"><h1 className="font-serif text-4xl">Company not found</h1></div>;
  if (!c) return <div className="max-w-3xl mx-auto px-6 py-24 text-mutedink">Loading…</div>;
  return (
    <div className="max-w-[1100px] mx-auto px-4 sm:px-6 py-10">
      <div className="text-xs text-mutedink mb-4"><Link to="/companies" className="hover:text-crimson">Companies</Link> <span className="text-hair">/</span> {c.name}</div>
      <div className="border border-hair p-8 bg-surface">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
          <div>
            <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink">{c.name}</h1>
            <div className="text-xs uppercase tracking-widest text-crimson font-bold mt-2">{c.company_type}</div>
            <div className="text-sm text-mutedink mt-1">{c.country}</div>
          </div>
          {c.website && <a href={c.website} target="_blank" rel="noreferrer" className="text-sm text-crimson flex items-center gap-1 hover:underline">{c.website.replace(/^https?:\/\//,"")} <ExternalLink size={13} /></a>}
        </div>
        <p className="text-ink2 leading-relaxed mt-5 max-w-3xl">{c.description}</p>
      </div>

      <div className="mt-12">
        <div className="border-b-2 border-ink pb-2 mb-6"><h2 className="font-serif font-bold text-2xl">Coverage</h2></div>
        {c.articles?.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {c.articles.map((a) => <ArticleCard key={a.id} a={a} variant="standard" />)}
          </div>
        ) : <p className="text-mutedink">No published coverage referencing {c.name} yet.</p>}
      </div>
    </div>
  );
}
